<template>
  <div class="q-pa-md q-gutter-sm">
    <q-btn
      label="Filtros"
      no-caps
      icon="filter_alt"
      color="primary"
      @click="abrirModal = true"
    />

    <q-dialog
      v-model="abrirModal"
      :persistent="persistent"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 800px; max-width: 90vw">
        <div class="bg-brand-1 text-white">
          <q-card-section>
            <div class="text-h6">Filtros - Relatório de Contratos</div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            Selecione os filtros desejados e clique em 'Filtrar' para gerar o
            relatório.
          </q-card-section>
        </div>

        <q-card-section>
          <div class="row q-gutter-md">
            <!-- Unidades/Vendors -->
            <div class="col-4">
              <div class="text-brand-5 text-weight-bold q-mb-sm">Unidades</div>
              <q-select
                dense
                outlined
                v-model="filtros.vendors"
                multiple
                option-label="nome"
                option-value="id"
                emit-value
                map-options
                :options="optionsUnidade"
                label="Selecione as unidades"
                use-chips
                clearable
              />
            </div>

            <!-- Fornecedor -->
            <div class="col-12 col-md-6">
              <SelecaoFornecedorContrato
                class="q-mt-sm"
                :labelSuperior="'Fornecedor'"
                :hidenLabel="true"
                @enviarFornecedor="receberFornecedor"
              />
            </div>

            <!-- Número do Contrato -->
            <div class="col-4">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                Número do Contrato
              </div>
              <q-input
                dense
                outlined
                v-model="filtros.contractNumber"
                label="Número do Contrato"
                placeholder="Digite o número do contrato"
                clearable
              />
            </div>

            <!-- Nome do Suprimento -->
            <div class="col-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                Tipo de Fornecimento
              </div>
              <q-select
                dense
                outlined
                v-model="filtros.supplyName"
                use-input
                @filter="filterSupplies"
                :options="suppliesOptions"
                option-label="name"
                option-value="name"
                emit-value
                map-options
                label="Selecione o tipo de fornecimento"
                clearable
              />
            </div>

            <!-- Período -->
            <div class="col-12">
              <q-tooltip>
                Esses campos são para indicar o inicio e o fim da vigencia
              </q-tooltip>
              <div class="text-brand-5 text-weight-bold q-mb-sm">Período</div>
              <div class="row q-gutter-sm">
                <div class="col-4">
                  <q-input
                    dense
                    outlined
                    placeholder="DD/MM/AAAA"
                    v-model="filtros.startDate"
                    mask="##/##/####"
                    label="Data Início"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date
                            :locale="myLocale"
                            mask="DD/MM/YYYY"
                            v-model="filtros.startDate"
                          >
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Fechar"
                                color="primary"
                                flat
                              />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>

                <div class="col-6 q-ml-sm">
                  <q-input
                    dense
                    outlined
                    placeholder="DD/MM/AAAA"
                    v-model="filtros.endDate"
                    mask="##/##/####"
                    label="Data Fim"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date
                            :locale="myLocale"
                            mask="DD/MM/YYYY"
                            v-model="filtros.endDate"
                          >
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Fechar"
                                color="primary"
                                flat
                              />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
            </div>

            <!-- Status -->
            <div class="col-4">
              <div class="text-brand-5 text-weight-bold q-mb-sm">Status</div>
              <q-select
                dense
                outlined
                v-model="filtros.status"
                :options="statusOptions"
                option-label="label"
                option-value="value"
                emit-value
                map-options
                label="Status do Contrato"
                clearable
              />
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal q-pa-md">
          <q-btn
            label="Limpar"
            no-caps
            flat
            color="grey-7"
            @click="limparFiltros"
            class="q-mr-sm"
          />
          <q-btn
            label="Filtrar"
            :loading="loading"
            no-caps
            icon="filter_alt"
            color="primary"
            @click="emitirFiltros"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import SelecaoFornecedorContrato from "./SelecaoFornecedorContrato.vue";

export default {
  components: {
    SelecaoFornecedorContrato,
  },
  props: ["loadingValue"],
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();

    const loading = ref(false);
    const abrirModal = ref(
      route.params.id != "" &&
        route.params.id != undefined &&
        route.params.id != "carregado"
        ? false
        : true
    );
    const persistent = ref(false);
    const id = route.params.id;

    const filtros = ref({
      vendors: [],
      providerSearch: "",
      contractNumber: "",
      startDate: "",
      endDate: "",
      supplyName: [],
      status: "",
    });

    const optionsUnidade = ref([]);
    const suppliesOptions = ref([]);

    const statusOptions = [
      "Todos",
      "Vigente",
      "Vencido",
      "Deletado",
      "Atendido",
    ];

    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };

    const emitirFiltros = async () => {
      loading.value = true;

      // Converter datas para formato correto (YYYY-MM-DD)
      const filtrosFormatados = { ...filtros.value };

      if (filtrosFormatados.startDate) {
        filtrosFormatados.startDate = filtrosFormatados.startDate
          .split("/")
          .reverse()
          .join("-");
      }

      if (filtrosFormatados.endDate) {
        filtrosFormatados.endDate = filtrosFormatados.endDate
          .split("/")
          .reverse()
          .join("-");
      }

      // Remover campos vazios
      Object.keys(filtrosFormatados).forEach((key) => {
        const value = filtrosFormatados[key];
        if (
          !value ||
          (Array.isArray(value) && value.length === 0) ||
          (typeof value === "string" && value.trim() === "")
        ) {
          delete filtrosFormatados[key];
        }
      });

      emit("filtrosContratos", filtrosFormatados);
    };

    const receberFornecedor = (fornecedor) => {
      if (fornecedor && fornecedor.cnpj) {
        filtros.value.providerSearch = fornecedor.cnpj;
      } else {
        filtros.value.providerSearch = "";
      }
    };

    const limparFiltros = () => {
      filtros.value = {
        vendors: [],
        providerSearch: "",
        contractNumber: "",
        startDate: "",
        endDate: "",
        supplies: "",
        status: "",
      };
    };

    const filterSupplies = async (val, update) => {
      try {
        const response = await store.dispatch("gdcStore/getSupplies", {
          name: val,
        });
        update(() => {
          suppliesOptions.value = response.data.result.data || [];
        });
      } catch (error) {
        console.error("Erro ao carregar tipos de fornecimento:", error);
        update(() => {
          suppliesOptions.value = [];
        });
      }
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        let array = response.listaUnidades;
        array.forEach((unidade) => {
          optionsUnidade.value.push({
            nome: unidade.nome,
            id: unidade.id,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    const verificarPersistencia = async () => {
      if (id) {
        persistent.value = false;
      }
    };

    watch(
      () => props.loadingValue,
      () => {
        loading.value = props.loadingValue;
        if (loading.value == false) {
          setTimeout(() => {
            abrirModal.value = false;
            persistent.value = false;
          }, 1000);
        }
      }
    );

    onMounted(() => {
      verificarPersistencia();
      listarUnidades();
    });

    return {
      abrirModal,
      persistent,
      loading,
      filtros,
      optionsUnidade,
      suppliesOptions,
      statusOptions,
      myLocale,
      emitirFiltros,
      limparFiltros,
      receberFornecedor,
      filterSupplies,
    };
  },
};
</script>

<style scoped>
.texto-titulo-input {
  font-size: 12px;
  margin-bottom: 4px;
}
</style>
